export const getMenuOptions = (options, isSuperUser, { isScopedAdmin = false } = {}) => {
    // `requireScopedAdmin` entries are fail-closed: shown ONLY when the BE has
    // confirmed the caller is a scoped practice admin (isScopedAdmin === true),
    // never on a client-side role guess. Superusers use their own SuperAdmin
    // surface, so the scoped entry stays hidden for them too.
    const gated = options.filter((ele) => !ele.requireScopedAdmin || isScopedAdmin === true);
    if (isSuperUser) return gated;
    return gated.filter((ele) => ele.value !== 'practice_chatbot');
};
